export default "__VITE_ASSET__SOBm2z8g__"